var _defs, _polygon, _polygon2, _polygon3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "142.22 409.47 895.54 381.06",
    width: 895.54,
    height: 381.06,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc1475;}.cls-2{fill:#fed330;}.cls-3{fill:#1261fb;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "455.36 590.26 142.22 409.47 142.22 771.05 455.36 590.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.34 593.41 202.02 534.91 202.02 651.9 303.34 593.41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "354.68 790.53 354.68 657.49 239.47 724.01 354.68 790.53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M582.48,661.24h-24.23v91.86h-46.77v-238.58h93.21c46.44,0,76.05,31.97,76.05,73.36,0,33.31-19.52,58.55-50.81,67.64l51.15,97.58h-51.82l-46.77-91.86Zm13.46-40.04c23.55,0,37.35-13.46,37.35-32.98s-13.8-33.31-37.35-33.31h-37.69v66.29h37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.46,753.1v-238.58h47.11v238.58h-47.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.43,698.59h-96.91l-19.85,54.51h-49.13l91.53-238.58h53.84l90.85,238.58h-50.47l-19.85-54.51Zm-81.43-42.4h65.95l-32.98-90.18-32.98,90.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiaLogo);
export default __webpack_public_path__ + "static/media/Ria_Logo.bf242d5a5bba03e9b9d5baacc6951232.svg";
export { ForwardRef as ReactComponent };